import { LoaderFunctionArgs, redirect } from "react-router-dom";

import { MyDate, myAxios } from "src/components/common/functions";

export async function dashboardLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => controller.abort());
    const url = new URL(request.url);
    const today = new MyDate().s();
    const monthStart = `${today.slice(0, 8)}01`;
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if (!["start", "end"].includes(key)) {
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.get("start")) {
        url.searchParams.set("start", monthStart);
        shouldRedirect = true;
    }
    if (!url.searchParams.get("end")) {
        url.searchParams.set("end", today);
        shouldRedirect = true;
    }
    if (shouldRedirect) {
        throw redirect(url.pathname + "?" + url.searchParams.toString());
    }
    const formData = new FormData();
    formData.append("start", url.searchParams.get("start")!);
    formData.append("end", url.searchParams.get("end")!);
    const res = await myAxios({
        fileName: "dashboard/readDashboard.php",
        formData,
        signal: controller.signal,
    });
    if (!res) throw redirect("..");
    return res.data;
}
